import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import { applyBrandDocumentTitle, startHostHeartbeat } from "./lib/hostConfig";
import { getActiveLocale, loadChromeOverlay } from "./lib/locale";

applyBrandDocumentTitle();
startHostHeartbeat();

function mount(): void {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// The chrome translations must be in place before the first screen with text;
// a slow or missing backend never holds the course back for long.
const bootLocale = getActiveLocale();
if (bootLocale === "en") {
  mount();
} else {
  let mounted = false;
  const go = () => {
    if (mounted) return;
    mounted = true;
    mount();
  };
  window.setTimeout(go, 2500);
  loadChromeOverlay(bootLocale).then(go, go);
}
